import React, { useEffect, useState } from "react";
import { post } from "../../../components/api";
import LoadDetailsCard from "../../../components/LoadDeatilsCard";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";

const LoadList = () => {
  const [loadList, setLoadList] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    fetchLoadList();
  }, []);
  const fetchLoadList = async () => {
    const response = await post("/company/ltms/get/load", {});

    if (response.status === 200) {
      setLoadList(response.data.loads);
    }
  };
  const handleAddLoad = () => {
    navigate("/company/add_load");
  };
  return (
    <div className="mainWrapper">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: "start",
          fontSize: "30px",
          fontWeight: "500",
          color: "rgba(68, 88, 95, 1)",
          padding: "10px 0px 20px 0px",
        }}
      >
        <p className="mb-0">Loads</p>
        <button className="load_button" onClick={handleAddLoad}>
          + Add loads
        </button>
      </div>
      <div className="row" style={{ cursor: "pointer" }}>
        {loadList.map((item, i) => (
          <div
            className="col-md-4 col-lg-3 col-sm-12 d-flex flex-column"
            style={{ height: "100%", paddingBottom: "16px" }}
            key={i}
          >
            <Link
              to={`/company/load`}
              state={item}
              style={{ color: "" }}
              className="text-decoration-none vehicle-info color-none"
            >
              <LoadDetailsCard
                details={item}
                setLoadList={setLoadList}
                loadList={loadList}
              />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadList;
